// @ts-nocheck

import palette from '../palette';

export const HighlightFilters = {
  color: palette.white,
  primaryBackground: palette.bluegrey850,
  secondaryBackground: palette.bluegrey925,
  primaryText: palette.neutralgrey300,
  selectedText: palette.white,
  closeSvgColor: palette.white,
  separator: palette.bluegrey700,
};

export const HighlightsContainer = {
  background: palette.bluegrey925,
  color: palette.white,
};
